module.exports = __webpack_public_path__ + "img/homepage_SaaS_img.0f3af46d.png";